export default {
  computed: {
    hasStripe() {
      return !!this.stripe
    }
  },

  data: function() {
    return {
      stripe: null,
      stripeElements: null,
      stripeConfig: {
        fonts: [
          {
            family: 'Source Sans Pro',
            style: 'normal',
            weight: 400,
            src:
              'url(https://fonts.gstatic.com/s/sourcesanspro/v14/6xK3dSBYKcSV-LCoeQqfX1RYOo3qOK7lujVj9w.woff2) format("woff2")'
          }
        ]
      }
    }
  },

  methods: {
    /**
     * Initialize stripe and stripe element objects
     * https://stripe.com/docs/js/initializing
     */
    initStripe(key) {
      if (!this.hasStripe || !this.elements) {
        this.stripe = window.Stripe(key)
        this.stripeElements = this.stripe.elements(this.stripeConfig)
      }
    },

    /**
     * Create a Stripe element and mount to specified ID
     * https://stripe.com/docs/js/elements_object/create_element?type=card
     */
    createStripeElement(name, id, component, onError = null) {
      if (!this.hasStripe) return

      let elem = null
      elem = this.stripeElements.create(name, {
        style: this.getStripeElementStyle()
      })
      elem.mount(`#${id}`)

      /* Trigger custom input focus detection */
      if (component) {
        component.toStripe()
      }

      /**
       * Add in Stripe's error handling
       * https://stripe.com/docs/js/element/events/on_change?type=cardElement#element_on_change-event
       */
      elem.on('change', e => {
        if (onError) {
          onError(name, e.error ? e.error.message : null)
        }
      })

      return elem
    },

    /**
     * Get styling to overwrite default Stripe element design
     * https://stripe.com/docs/js/appendix/style
     */
    getStripeElementStyle() {
      return {
        /* All other variants inherit from these styles */
        base: {
          fontFamily: 'Source Sans Pro, sans-serif',
          fontWeight: '400',
          fontSize: '15.6px',
          fontSmoothing: 'antialiased',
          color: '#1C1C1C',
          /* Hide the placeholder as the Custom Input will re-create one */
          '::placeholder': {
            color: 'transparent',
            textShadow: 'none'
          }
        },
        /* Applied when the Element has valid input */
        complete: {},
        /* Applied when the Element has no customer input */
        empty: {},
        /* Applied when the Element has invalid input */
        invalid: {}
      }
    }
  }
}
